import { Component, Input, TemplateRef } from "@angular/core";
import { ɵa as NzBadgeSupComponent } from "ng-zorro-antd/badge";
import { NzSafeAny } from "ng-zorro-antd/core/types";

@Component({
  selector: "ui-badge-sup",
  exportAs: "uiBadgeSup",
  templateUrl: "./badge-sup.component.html",
})
export class UiBadgeSupComponent extends NzBadgeSupComponent {
  @Input("uiOffset") public nzOffset?: [number, number];
  @Input("uiTitle") public nzTitle?: string | null | undefined;
  @Input("uiStyle") public nzStyle: { [key: string]: string } | null = null;
  @Input("uiDot") public nzDot = false;
  @Input("uiOverflowCount") public nzOverflowCount = 99;
  @Input("uiCount") public nzCount?: number | TemplateRef<NzSafeAny>;
}
